import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class RegisterMachineHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	initMachine(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/init_machine';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(resp => {
				observer.next(resp);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getRegistration(serialNo){
		return new Observable((observer: any) => {
			const path = '/dashboard/get_mac_registration/'+serialNo;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateRegistration(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/update_mac_registration';
			const params = {
				body: formObj
			};
			API.put(this.apiName, path, params).then(resp => {
				observer.next(resp);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getRegions() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-regions';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getTerritories(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-territories';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}


}
